﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as api from "~base/Services/API";
import * as accountModel from "./Model";
//-------------------------------------------------------------------------------------
// Constants
//-------------------------------------------------------------------------------------

const uri = "api/account/v1/user/register";
const method = "POST";

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

interface PostRegisterProps extends api.ApiHookBaseProps<
    accountModel.PostRegisterRequest,
    unknown,
    unknown
> {}

//-------------------------------------------------------------------------------------
// API Hook
//-------------------------------------------------------------------------------------

export function usePostAccountRegister(
    props: PostRegisterProps
): [boolean, (data: accountModel.PostRegisterRequest) => Promise<unknown>] {
    const apiParams: api.ApiHookProps<
        accountModel.PostRegisterRequest,
        unknown,
        unknown
    > = {
        ...props,
        uri: uri,
        method: method,
        skipResponseParsing: true,
    };

    const [loading, invoker] = api.useApi<
        accountModel.PostRegisterRequest,
        unknown,
        unknown
    >(apiParams);
    return [loading, (data) => invoker(apiParams.uri, data)];
}
